import { useEffect, useState, useContext } from "react";
import { api } from "../App";
import Card from "./card";
import Loading from "./loading";

const Workshops = () => {
  const { apiData } = useContext(api);
  const [workshops, setWorkshops] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const data = apiData.filter((obj) =>
      obj.tags?.some((obj) => obj.name === "workshops")
    );
    setWorkshops(data);
  }, [apiData]);

  useEffect(() => {
    if (workshops.length || (!workshops.length && apiData.length)) {
      setLoading(false);
    }
  }, [workshops, apiData]);

  return loading ? (
    <Loading />
  ) : (
    <div className="api-data">
      {!!workshops.length ? (
        workshops.map((obj) => <Card obj={obj} key={obj.id} />)
      ) : (
        <p className="nothing">There is nothing coming up at this time.</p>
      )}
    </div>
  );
};

export default Workshops;
